import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

/**
 * Reusable county autocomplete for bond forms and endorsement dialogs.
 */
export default function CountyAutocompleteField({
  options,
  loading,
  value,
  onChange,
  label = "County",
  disabled = false,
  required = false,
  error = false,
  helperText,
  sx,
  getOptionLabel,
  isOptionEqualToValue,
}) {
  const resolvedValue =
    value && typeof value === "object"
      ? value
      : options.find((option) => {
          const optionValue = typeof option === "string" ? option : option.value;
          return optionValue === value;
        }) || (value || null);

  return (
    <Autocomplete
      options={options}
      loading={loading}
      value={resolvedValue}
      onChange={(event, selected) => onChange(event, selected)}
      getOptionLabel={
        getOptionLabel ||
        ((option) => (typeof option === "string" ? option : option.label || option.value || ""))
      }
      isOptionEqualToValue={
        isOptionEqualToValue ||
        ((option, selected) => {
          if (!option || !selected) return option === selected;
          if (typeof option === "string" || typeof selected === "string") {
            return option === selected;
          }
          return option.value === selected.value;
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={18} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
      fullWidth
      disabled={disabled || loading}
      sx={sx}
    />
  );
}

CountyAutocompleteField.propTypes = {
  options: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  sx: PropTypes.object,
  getOptionLabel: PropTypes.func,
  isOptionEqualToValue: PropTypes.func,
};
